import React from "react";

const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    style={{ width: "24px", height: "24px", aspectRatio: "1/1" }}
    {...props}
  >
    <g clipPath="url(#clip0_5825_5790)">
      <path d="M19.25 13.5898H13.25V19.5898H11.25V13.5898H5.25V11.5898H11.25V5.58984H13.25V11.5898H19.25V13.5898Z" fill="var(--theme-palette-primary-main)" />
    </g>
    <defs>
      <clipPath id="clip0_5825_5790">
        <rect width="24" height="24" fill="var(--theme-palette-primary-contrastText)" transform="translate(0.25 0.589844)" />
      </clipPath>
    </defs>
  </svg>
);

export default PlusIcon;
